import { atom } from 'jotai';

import type { Loggers } from '../types/logger';

export const loggersAtom = atom<Loggers>([]);
